<template>
    <textarea
        class="
            block w-full rounded-md border-gray-300 shadow-sm
            focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
        "
        :class="{'border-red-500': hasError}"
        v-model="model"/>
</template>

<script>

import FormInput from "@/Mixins/FormInput";

export default {

    name: "Textarea",

    mixins: [FormInput],
};

</script>
